import * as React from 'react';
import {
  DateFormatterCollection,
  DateRange,
  MetricBlue,
  MetricComparisonColor,
  MetricsGrey,
} from '@tableau/metrics-engine';

export interface MetricLegendProps {
  readonly currentRange: DateRange;
  readonly comparisonRange?: DateRange;
  readonly dateFormatter: DateFormatterCollection;
  readonly metricColorIndicatorsEnabled?: boolean;
}

export class MetricLegend extends React.Component<MetricLegendProps, {}> {
  private renderLegend = (color: string, dateRange: DateRange, windowSwitcherDescribedById: string) => {
    return (
      <div style={container}>
        <div style={{ ...box, backgroundColor: color }} />
        <div style={text} id={windowSwitcherDescribedById}>
          {this.props.dateFormatter.legend(dateRange)}{' '}
        </div>
      </div>
    );
  };
  public render = (): JSX.Element | null => {
    const color = this.props.metricColorIndicatorsEnabled ? MetricsGrey : MetricBlue;
    return (
      <div>
        {this.renderLegend(color, this.props.currentRange, 'current-legend')}
        {this.props.comparisonRange
          ? this.renderLegend(MetricComparisonColor, this.props.comparisonRange, 'comparison-legend')
          : null}
      </div>
    );
  };
}

const container = {
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '5px',
  marginBottom: '5px',
  height: '20px',
};

const box = {
  height: '14px',
  width: '14px',
  borderRadius: '2px',
  marginRight: '2px',
};

const text = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '5px',
};
